// extracted by mini-css-extract-plugin
export default {"container":"ColorPreview_container__FbYKL","inlineContainer":"ColorPreview_inlineContainer__wr+yr","fillParent":"ColorPreview_fillParent__KFAOP"};